export default __webpack_public_path__ + "react/assets/png/group-5@3x.png";